import { useEffect, useState } from "react";
import problemServices from "app/services/problem-service";

const useProblemDetailsByName = (name) => {
  const [problemDetailsByName, setProblemDetailsByName] = useState(null);
  const [loading, setLoading] = useState(false); // Start false to avoid initial load
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProblemDetailsByName = async () => {
      setLoading(true);
      try {
        const res = await problemServices.getProblemDetails(name);
        if (!res) {
          console.warn("No problem details returned for name:", name);
          setProblemDetailsByName(null);
        } else {
          setProblemDetailsByName(res);
        }
      } catch (error) {
        console.error("Error fetching problem details by name:", error);
        setProblemDetailsByName(null);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    if (name) {
      fetchProblemDetailsByName();
    } else {
      setProblemDetailsByName(null);
      setLoading(false); // Explicitly set false when no name
    }
  }, [name]);

  return { problemDetailsByName, loading, error };
};

export default useProblemDetailsByName;
